import { getLanguage } from '@/utils/utils'

// 共用页面
import Overview from '@/pages/commom/Overview'
import PlayerStatistic from '@/pages/commom/PlayerStatistic'
import DiamondStatistic from '@/pages/commom/DiamondStatistic'
import DiamondOpeningStartStatistic from '@/pages/commom/DiamondOpeningStartStatistic'
import DiamondExchangeIntegralStatistic from '@/pages/commom/DiamondExchangeIntegralStatistic'
import DiamondDistributionStatistic from '@/pages/commom/DiamondDistributionStatistic'
import DiamondRecord from '@/pages/commom/DiamondRecord'
import ClubDetail from '@/pages/commom/ClubDetail'
import PlayerList from '@/pages/commom/PlayerList'
import PlayerDetail from '@/pages/commom/PlayerDetail'
import TableConfigList from '@/pages/commom/TableConfigList'
import TableRoundList from '@/pages/commom/TableRoundList'
import TableRoundRecordList from '@/pages/commom/TableRoundRecordList'
import TableConfigStatistic from '@/pages/commom/TableConfigStatistic'
import MttCreate from '@/pages/commom/MttCreate'
import MttList from '@/pages/commom/MttList'
import MttRoundList from '@/pages/commom/MttRoundList'
import MttTicket from '@/pages/commom/MttTicket'
import MttTicketList from '@/pages/commom/MttTicketList'
import MttDataStatistic from '@/pages/commom/MttDataStatistic'
import AccountManage from '@/pages/commom/AccountManage'
import AccountSetting from '@/pages/commom/AccountSetting'
import AccountSwitch from '@/pages/commom/AccountSwitch'
import Page404 from '@/pages/commom/Page404.js'

// 超级联盟
import SuperUnionIncomeStatistic from '@/pages/superUnion/IncomeStatistic'
import SuperUnionLowerLevelStatistic from '@/pages/superUnion/LowerLevelStatistic'
import SuperUnionGameStatistic from '@/pages/superUnion/GameStatistic'
import SuperUnionIntegralConsumeStatistic from '@/pages/superUnion/IntegralConsumeStatistic'
import SuperUnionCheckDataStatistic from '@/pages/superUnion/CheckDataStatistic'
import SuperUnionKpokerUnionBetRecord from '@/pages/superUnion/KpokerUnionBetRecord'
import SuperUnionKpokerUnionIntegralRecord from '@/pages/superUnion/KpokerUnionIntegralRecord'
import SuperUnionActivityLuckycard from '@/pages/superUnion/ActivityLuckycard'
import SuperUnionActivityLuckycardRecord from '@/pages/superUnion/ActivityLuckycardRecord'
import SuperUnionActivityLuckycardRewardReview from '@/pages/superUnion/ActivityLuckycardRewardReview'
import SuperUnionActivityBadBeatJackpot from '@/pages/superUnion/ActivityBadBeatJackpot'
import SuperUnionActivityBadBeatJackpotRewardRecord from '@/pages/superUnion/ActivityBadBeatJackpotRewardRecord'
import SuperUnionActivityHighHandCard from '@/pages/superUnion/ActivityHighHandCard'
import SuperUnionActivityRank from '@/pages/superUnion/ActivityHandRank'
import SuperUnionActivityDailyChallenge from '@/pages/superUnion/ActivityDailyChallenge'
import SuperUnionActivityDailyChallengeRecord from '@/pages/superUnion/ActivityDailyChallengeRecord'
import SuperUnionActivityDailyChallengeDetail from '@/pages/superUnion/ActivityDailyChallengeDetail'
import SuperUnionActivityPoster from '@/pages/superUnion/ActivityPoster'
import SuperUnionUnionList from '@/pages/superUnion/UnionList'
import SuperUnionUnionDetail from '@/pages/superUnion/UnionDetail'
import SuperUnionClubList from '@/pages/superUnion/ClubList'
import SuperUnionPartnerCardQuery from '@/pages/superUnion/PartnerCardQuery'
import SuperUnionPartnerCardStatistic from '@/pages/superUnion/PartnerCardStatistic'
import SuperUnionDerivativeDetection from '@/pages/superUnion/DerivativeDetection'
import SuperUnionCodeSendRecord from '@/pages/superUnion/CodeSendRecord'
import SuperUnionIntegralTransferRecord from '@/pages/superUnion/IntegralTransferRecord'
import SuperUnionGameCurrencyTypeProportion from '@/pages/superUnion/GameCurrencyTypeProportion'
import SuperUnionIpGpsWhitelist from '@/pages/superUnion/IpGpsWhitelist'
import SuperUnionCustomerManage from '@/pages/superUnion/CustomerManage'
import SuperUnionSignaturePackageDownloadConfiguration from '@/pages/superUnion/SignaturePackageDownloadConfiguration'

// 联盟
import UnionIncomeStatistic from '@/pages/union/IncomeStatistic'
import UnionPaymentStatistic from '@/pages/union/PaymentStatistic'
import UnionLowerLevelPaymentStatistic from '@/pages/union/LowerLevelPaymentStatistic'
import UnionGameStatistic from '@/pages/union/GameStatistic'
import UnionConsumeIntegralStatistic from '@/pages/union/IntegralConsumeStatistic'
import UnionClubList from '@/pages/union/ClubList'
import UnionLocalCurrencyRatio from '@/pages/union/LocalCurrencyRatio'

// 直营联盟
import DirectUnionIncomeStatistic from '@/pages/union/IncomeStatistic'
import DirectUnionGameStatistic from '@/pages/union/GameStatistic'
import DirectUnionIntegralConsumeStatistic from '@/pages/union/IntegralConsumeStatistic'
import DirectUnionLowerLevelProxyStatistic from '@/pages/union/LowerLevelProxyStatistic'
import DirectUnionClubList from '@/pages/union/ClubList'

// Kpoker联盟
import KpokerProxyList from '@/pages/kpokerUnion/ProxyList'
import KpokerProxyDetail from '@/pages/kpokerUnion/ProxyDetail'
import KpokerIncomeStatistic from '@/pages/kpokerUnion/IncomeStatistic'
import KpokerIncomeRecord from '@/pages/kpokerUnion/IncomeRecord'
import KpokerPaymentStatistic from '@/pages/kpokerUnion/PaymentStatistic'
import KpokerProxyStatistic from '@/pages/kpokerUnion/ProxyStatistic'
import KpokerPalyerStatistic from '@/pages/kpokerUnion/PalyerStatistic'
import KpokerGamblingRecord from '@/pages/kpokerUnion/GamblingRecord'
import KpokerBetRecord from '@/pages/kpokerUnion/BetRecord'
import KpokerIntegralRecord from '@/pages/kpokerUnion/IntegralRecord'
import KpokerPropConsumeRecord from '@/pages/kpokerUnion/PropConsumeRecord'
import KpokerIntegralProportion from '@/pages/kpokerUnion/IntegralProportion'

/**
 * @description 路由参数说明
 * path {string} 路径
 * key {string} 菜单标题key
 * icon {string} 菜单图标
 * showMenu {Boolean} 是否在菜单中显示，值为false则不显示
 * */

// ############################################################################################## 超盟 ##############################################################################################
/**
 * 超盟主
 */
export const superUnionMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionIncomeStatistic,
    },
    {
        path: '/lower_level_statistic',
        title: getLanguage('lowerLevelStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: SuperUnionLowerLevelStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: SuperUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionIntegralConsumeStatistic,
    },
    {
        path: '/check_data_statistic',
        title: getLanguage('checkDataStatistic'),
        icon: 'check-circle',
        showMenu: true,
        component: SuperUnionCheckDataStatistic,
    },
    {
        path: '/kpoker_union_bet_record',
        title: getLanguage('kpokerUnionBetRecord'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionKpokerUnionBetRecord,
    },
    {
        path: '/kpoker_union_integral_record',
        title: getLanguage('kpokerUnionIntegralRecord'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionKpokerUnionIntegralRecord,
    },
    {
        path: '/integral_transfer_record',
        title: getLanguage('integralTransferRecord'),
        icon: 'retweet',
        showMenu: true,
        component: SuperUnionIntegralTransferRecord,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
            {
                path: '/diamond_opening_start_statistic',
                title: getLanguage('diamondOpeningStartStatistic'),
                showMenu: true,
                component: DiamondOpeningStartStatistic,
            },
            {
                path: '/diamond_exchange_integral_statistic',
                title: getLanguage('diamondExchangeIntegralStatistic'),
                showMenu: true,
                component: DiamondExchangeIntegralStatistic,
            },
            {
                path: '/diamond_distribution_statistic',
                title: getLanguage('diamondDistributionStatistic'),
                showMenu: true,
                component: DiamondDistributionStatistic,
            },
            {
                path: '/diamond_record',
                title: getLanguage('diamondRecord'),
                showMenu: true,
                component: DiamondRecord,
            },
        ],
    },
    {
        path: '/activity_manage',
        title: getLanguage('activityManage'),
        icon: 'credit-card',
        showMenu: true,
        children: [
            {
                path: '/activity_lucky_card',
                title: getLanguage('activityLuckyCard'),
                showMenu: true,
                component: SuperUnionActivityLuckycard,
            },
            {
                path: '/activity_lucky_card_record',
                title: getLanguage('activityLuckyCardRecord'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRecord,
            },
            {
                path: '/activity_lucky_card_reward_review',
                title: getLanguage('activityLuckyCardRewardReview'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRewardReview,
            },
            {
                path: '/activity_bad_beat_jackpot',
                title: getLanguage('activityBadBeatJackpot'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpot,
            },
            {
                path: '/activity_bad_beat_jackpot_reward_record',
                title: getLanguage('activityBadBeatJackpotRewardRecord'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpotRewardRecord,
            },
            {
                path: '/activity_high_hand_card',
                title: getLanguage('activityHighHandCard'),
                showMenu: true,
                component: SuperUnionActivityHighHandCard,
            },
            {
                path: '/activity_hand_rank',
                title: getLanguage('activityHandRank'),
                showMenu: true,
                component: SuperUnionActivityRank,
            },
            {
                path: '/activity_daily_challenge',
                title: getLanguage('dailyChallenge'),
                showMenu: true,
                component: SuperUnionActivityDailyChallenge,
            },
            {
                path: '/activity_daily_challenge_record',
                title: getLanguage('dailyChallengeRecord'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeRecord,
            },
            {
                path: '/activity_daily_challenge_detail',
                title: getLanguage('dailyChallengeDetail'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeDetail,
            },
            {
                path: '/activity_poster',
                title: getLanguage('activityPoster'),
                showMenu: true,
                component: SuperUnionActivityPoster,
            },
        ],
    },
    {
        path: '/union_manage',
        title: getLanguage('unionManage'),
        icon: 'apartment',
        showMenu: true,
        children: [
            {
                path: '/union_list',
                title: getLanguage('unionList'),
                showMenu: true,
                component: SuperUnionUnionList,
            },
            {
                path: '/union_detail/:union_id',
                title: getLanguage('unionDetail'),
                showMenu: false,
                component: SuperUnionUnionDetail,
            },
        ],
    },
    {
        path: '/club_manage',
        title: getLanguage('clubManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('clubList'),
                showMenu: true,
                component: SuperUnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('clubDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket',
                title: getLanguage('mttTicket'),
                showMenu: true,
                component: MttTicket,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/partner_manage',
        title: getLanguage('partnerManage'),
        icon: 'alert',
        showMenu: true,
        children: [
            {
                path: '/partner_card_query',
                title: getLanguage('partnerCardQuery'),
                showMenu: true,
                component: SuperUnionPartnerCardQuery,
            },
            {
                path: '/partner_card_statistic',
                title: getLanguage('partnerCardStatistic'),
                showMenu: true,
                component: SuperUnionPartnerCardStatistic,
            },
        ],
    },
    {
        path: '/derivative_detection',
        title: getLanguage('derivativeDetection'),
        icon: 'bulb',
        showMenu: true,
        component: SuperUnionDerivativeDetection,
    },
    {
        path: '/game_currency_type_proportion',
        title: getLanguage('gameCurrencyTypeProportion'),
        icon: 'percentage',
        showMenu: true,
        component: SuperUnionGameCurrencyTypeProportion,
    },
    {
        path: '/ip_gps_white_list',
        title: getLanguage('ipGpsWhitelist'),
        icon: 'safety',
        showMenu: true,
        component: SuperUnionIpGpsWhitelist,
    },
    {
        path: '/code_send_record',
        title: getLanguage('codeSendRecord'),
        icon: 'history',
        showMenu: true,
        component: SuperUnionCodeSendRecord,
    },
    {
        path: '/customer_manage',
        title: getLanguage('customerManage'),
        icon: 'message',
        showMenu: true,
        component: SuperUnionCustomerManage,
    },
    {
        path: '/signature_package_download_configuration',
        title: getLanguage('signaturePackageDownloadConfiguration'),
        icon: 'download',
        showMenu: true,
        component: SuperUnionSignaturePackageDownloadConfiguration,
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 超盟vip
 */
export const superUnionVipMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionIncomeStatistic,
    },
    {
        path: '/lower_level_statistic',
        title: getLanguage('lowerLevelStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: SuperUnionLowerLevelStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: SuperUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionIntegralConsumeStatistic,
    },
    {
        path: '/check_data_statistic',
        title: getLanguage('checkDataStatistic'),
        icon: 'check-circle',
        showMenu: true,
        component: SuperUnionCheckDataStatistic,
    },
    {
        path: '/kpoker_union_bet_record',
        title: getLanguage('kpokerUnionBetRecord'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionKpokerUnionBetRecord,
    },
    {
        path: '/kpoker_union_integral_record',
        title: getLanguage('kpokerUnionIntegralRecord'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionKpokerUnionIntegralRecord,
    },
    {
        path: '/integral_transfer_record',
        title: getLanguage('integralTransferRecord'),
        icon: 'retweet',
        showMenu: true,
        component: SuperUnionIntegralTransferRecord,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
            {
                path: '/diamond_opening_start_statistic',
                title: getLanguage('diamondOpeningStartStatistic'),
                showMenu: true,
                component: DiamondOpeningStartStatistic,
            },
            {
                path: '/diamond_exchange_integral_statistic',
                title: getLanguage('diamondExchangeIntegralStatistic'),
                showMenu: true,
                component: DiamondExchangeIntegralStatistic,
            },
            {
                path: '/diamond_distribution_statistic',
                title: getLanguage('diamondDistributionStatistic'),
                showMenu: true,
                component: DiamondDistributionStatistic,
            },
            {
                path: '/diamond_record',
                title: getLanguage('diamondRecord'),
                showMenu: true,
                component: DiamondRecord,
            },
        ],
    },
    {
        path: '/activity_manage',
        title: getLanguage('activityManage'),
        icon: 'credit-card',
        showMenu: true,
        children: [
            {
                path: '/activity_lucky_card',
                title: getLanguage('activityLuckyCard'),
                showMenu: true,
                component: SuperUnionActivityLuckycard,
            },
            {
                path: '/activity_lucky_card_record',
                title: getLanguage('activityLuckyCardRecord'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRecord,
            },
            {
                path: '/activity_lucky_card_reward_review',
                title: getLanguage('activityLuckyCardRewardReview'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRewardReview,
            },
            {
                path: '/activity_bad_beat_jackpot',
                title: getLanguage('activityBadBeatJackpot'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpot,
            },
            {
                path: '/activity_bad_beat_jackpot_reward_record',
                title: getLanguage('activityBadBeatJackpotRewardRecord'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpotRewardRecord,
            },
            {
                path: '/activity_high_hand_card',
                title: getLanguage('activityHighHandCard'),
                showMenu: true,
                component: SuperUnionActivityHighHandCard,
            },
            {
                path: '/activity_hand_rank',
                title: getLanguage('activityHandRank'),
                showMenu: true,
                component: SuperUnionActivityRank,
            },
            {
                path: '/activity_daily_challenge',
                title: getLanguage('dailyChallenge'),
                showMenu: true,
                component: SuperUnionActivityDailyChallenge,
            },
            {
                path: '/activity_daily_challenge_record',
                title: getLanguage('dailyChallengeRecord'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeRecord,
            },
            {
                path: '/activity_daily_challenge_detail',
                title: getLanguage('dailyChallengeDetail'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeDetail,
            },
            {
                path: '/activity_poster',
                title: getLanguage('activityPoster'),
                showMenu: true,
                component: SuperUnionActivityPoster,
            },
        ],
    },
    {
        path: '/union_manage',
        title: getLanguage('unionManage'),
        icon: 'apartment',
        showMenu: true,
        children: [
            {
                path: '/union_list',
                title: getLanguage('unionList'),
                showMenu: true,
                component: SuperUnionUnionList,
            },
            {
                path: '/union_detail/:union_id',
                title: getLanguage('unionDetail'),
                showMenu: false,
                component: SuperUnionUnionDetail,
            },
        ],
    },
    {
        path: '/club_manage',
        title: getLanguage('clubManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('clubList'),
                showMenu: true,
                component: SuperUnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('clubDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket',
                title: getLanguage('mttTicket'),
                showMenu: true,
                component: MttTicket,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/partner_manage',
        title: getLanguage('partnerManage'),
        icon: 'alert',
        showMenu: true,
        children: [
            {
                path: '/partner_card_query',
                title: getLanguage('partnerCardQuery'),
                showMenu: true,
                component: SuperUnionPartnerCardQuery,
            },
            {
                path: '/partner_card_statistic',
                title: getLanguage('partnerCardStatistic'),
                showMenu: true,
                component: SuperUnionPartnerCardStatistic,
            },
        ],
    },
    {
        path: '/derivative_detection',
        title: getLanguage('derivativeDetection'),
        icon: 'bulb',
        showMenu: true,
        component: SuperUnionDerivativeDetection,
    },
    {
        path: '/game_currency_type_proportion',
        title: getLanguage('gameCurrencyTypeProportion'),
        icon: 'percentage',
        showMenu: true,
        component: SuperUnionGameCurrencyTypeProportion,
    },
    {
        path: '/ip_gps_white_list',
        title: getLanguage('ipGpsWhitelist'),
        icon: 'safety',
        showMenu: true,
        component: SuperUnionIpGpsWhitelist,
    },
    {
        path: '/code_send_record',
        title: getLanguage('codeSendRecord'),
        icon: 'history',
        showMenu: true,
        component: SuperUnionCodeSendRecord,
    },
    {
        path: '/customer_manage',
        title: getLanguage('customerManage'),
        icon: 'message',
        showMenu: true,
        component: SuperUnionCustomerManage,
    },
    {
        path: '/signature_package_download_configuration',
        title: getLanguage('signaturePackageDownloadConfiguration'),
        icon: 'download',
        showMenu: true,
        component: SuperUnionSignaturePackageDownloadConfiguration,
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '/account_switch',
        title: getLanguage('accountSwitch'),
        showMenu: false,
        component: AccountSwitch,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 超盟管理员
 */
export const superUnionAdminMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionIncomeStatistic,
    },
    {
        path: '/lower_level_statistic',
        title: getLanguage('lowerLevelStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: SuperUnionLowerLevelStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: SuperUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionIntegralConsumeStatistic,
    },
    {
        path: '/check_data_statistic',
        title: getLanguage('checkDataStatistic'),
        icon: 'check-circle',
        showMenu: true,
        component: SuperUnionCheckDataStatistic,
    },
    {
        path: '/kpoker_union_bet_record',
        title: getLanguage('kpokerUnionBetRecord'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionKpokerUnionBetRecord,
    },
    {
        path: '/kpoker_union_integral_record',
        title: getLanguage('kpokerUnionIntegralRecord'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionKpokerUnionIntegralRecord,
    },
    {
        path: '/integral_transfer_record',
        title: getLanguage('integralTransferRecord'),
        icon: 'retweet',
        showMenu: true,
        component: SuperUnionIntegralTransferRecord,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
            {
                path: '/diamond_opening_start_statistic',
                title: getLanguage('diamondOpeningStartStatistic'),
                showMenu: true,
                component: DiamondOpeningStartStatistic,
            },
            {
                path: '/diamond_exchange_integral_statistic',
                title: getLanguage('diamondExchangeIntegralStatistic'),
                showMenu: true,
                component: DiamondExchangeIntegralStatistic,
            },
            {
                path: '/diamond_distribution_statistic',
                title: getLanguage('diamondDistributionStatistic'),
                showMenu: true,
                component: DiamondDistributionStatistic,
            },
            {
                path: '/diamond_record',
                title: getLanguage('diamondRecord'),
                showMenu: true,
                component: DiamondRecord,
            },
        ],
    },
    {
        path: '/activity_manage',
        title: getLanguage('activityManage'),
        icon: 'credit-card',
        showMenu: true,
        children: [
            {
                path: '/activity_lucky_card',
                title: getLanguage('activityLuckyCard'),
                showMenu: true,
                component: SuperUnionActivityLuckycard,
            },
            {
                path: '/activity_lucky_card_record',
                title: getLanguage('activityLuckyCardRecord'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRecord,
            },
            {
                path: '/activity_lucky_card_reward_review',
                title: getLanguage('activityLuckyCardRewardReview'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRewardReview,
            },
            {
                path: '/activity_bad_beat_jackpot',
                title: getLanguage('activityBadBeatJackpot'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpot,
            },
            {
                path: '/activity_bad_beat_jackpot_reward_record',
                title: getLanguage('activityBadBeatJackpotRewardRecord'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpotRewardRecord,
            },
            {
                path: '/activity_high_hand_card',
                title: getLanguage('activityHighHandCard'),
                showMenu: true,
                component: SuperUnionActivityHighHandCard,
            },
            {
                path: '/activity_hand_rank',
                title: getLanguage('activityHandRank'),
                showMenu: true,
                component: SuperUnionActivityRank,
            },
            {
                path: '/activity_daily_challenge',
                title: getLanguage('dailyChallenge'),
                showMenu: true,
                component: SuperUnionActivityDailyChallenge,
            },
            {
                path: '/activity_daily_challenge_record',
                title: getLanguage('dailyChallengeRecord'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeRecord,
            },
            {
                path: '/activity_daily_challenge_detail',
                title: getLanguage('dailyChallengeDetail'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeDetail,
            },
            {
                path: '/activity_poster',
                title: getLanguage('activityPoster'),
                showMenu: true,
                component: SuperUnionActivityPoster,
            },
        ],
    },
    {
        path: '/union_manage',
        title: getLanguage('unionManage'),
        icon: 'apartment',
        showMenu: true,
        children: [
            {
                path: '/union_list',
                title: getLanguage('unionList'),
                showMenu: true,
                component: SuperUnionUnionList,
            },
            {
                path: '/union_detail/:union_id',
                title: getLanguage('unionDetail'),
                showMenu: false,
                component: SuperUnionUnionDetail,
            },
        ],
    },
    {
        path: '/club_manage',
        title: getLanguage('clubManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('clubList'),
                showMenu: true,
                component: SuperUnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('clubDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket',
                title: getLanguage('mttTicket'),
                showMenu: true,
                component: MttTicket,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/partner_manage',
        title: getLanguage('partnerManage'),
        icon: 'alert',
        showMenu: true,
        children: [
            {
                path: '/partner_card_query',
                title: getLanguage('partnerCardQuery'),
                showMenu: true,
                component: SuperUnionPartnerCardQuery,
            },
            {
                path: '/partner_card_statistic',
                title: getLanguage('partnerCardStatistic'),
                showMenu: true,
                component: SuperUnionPartnerCardStatistic,
            },
        ],
    },
    {
        path: '/derivative_detection',
        title: getLanguage('derivativeDetection'),
        icon: 'bulb',
        showMenu: true,
        component: SuperUnionDerivativeDetection,
    },
    {
        path: '/game_currency_type_proportion',
        title: getLanguage('gameCurrencyTypeProportion'),
        icon: 'percentage',
        showMenu: true,
        component: SuperUnionGameCurrencyTypeProportion,
    },
    {
        path: '/ip_gps_white_list',
        title: getLanguage('ipGpsWhitelist'),
        icon: 'safety',
        showMenu: true,
        component: SuperUnionIpGpsWhitelist,
    },
    {
        path: '/code_send_record',
        title: getLanguage('codeSendRecord'),
        icon: 'history',
        showMenu: true,
        component: SuperUnionCodeSendRecord,
    },
    {
        path: '/customer_manage',
        title: getLanguage('customerManage'),
        icon: 'message',
        showMenu: true,
        component: SuperUnionCustomerManage,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 超盟客服
 */
export const superUnionAdminServiceMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/activity_lucky_card',
    },
    {
        path: '/activity_manage',
        title: getLanguage('activityManage'),
        icon: 'credit-card',
        showMenu: true,
        children: [
            {
                path: '/activity_lucky_card',
                title: getLanguage('activityLuckyCard'),
                showMenu: true,
                component: SuperUnionActivityLuckycard,
            },
            {
                path: '/activity_lucky_card_record',
                title: getLanguage('activityLuckyCardRecord'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRecord,
            },
            {
                path: '/activity_bad_beat_jackpot_reward_record',
                title: getLanguage('activityBadBeatJackpotRewardRecord'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpotRewardRecord,
            },
            {
                path: '/activity_daily_challenge_record',
                title: getLanguage('dailyChallengeRecord'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeRecord,
            },
            {
                path: '/activity_daily_challenge_detail',
                title: getLanguage('dailyChallengeDetail'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeDetail,
            },
            {
                path: '/activity_poster',
                title: getLanguage('activityPoster'),
                showMenu: true,
                component: SuperUnionActivityPoster,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
        ],
    },
    {
        path: '/partner_manage',
        title: getLanguage('partnerManage'),
        icon: 'alert',
        showMenu: true,
        children: [
            {
                path: '/partner_card_query',
                title: getLanguage('partnerCardQuery'),
                showMenu: true,
                component: SuperUnionPartnerCardQuery,
            },
            {
                path: '/partner_card_statistic',
                title: getLanguage('partnerCardStatistic'),
                showMenu: true,
                component: SuperUnionPartnerCardStatistic,
            },
        ],
    },
    {
        path: '/derivative_detection',
        title: getLanguage('derivativeDetection'),
        icon: 'bulb',
        showMenu: true,
        component: SuperUnionDerivativeDetection,
    },
    {
        path: '/code_send_record',
        title: getLanguage('codeSendRecord'),
        icon: 'history',
        showMenu: true,
        component: SuperUnionCodeSendRecord,
    },
    {
        path: '/customer_manage',
        title: getLanguage('customerManage'),
        icon: 'message',
        showMenu: true,
        component: SuperUnionCustomerManage,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 超盟商务
 */
export const superUnionAdminFinanceMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionIncomeStatistic,
    },
    {
        path: '/lower_level_statistic',
        title: getLanguage('lowerLevelStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: SuperUnionLowerLevelStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: SuperUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionIntegralConsumeStatistic,
    },
    {
        path: '/check_data_statistic',
        title: getLanguage('checkDataStatistic'),
        icon: 'check-circle',
        showMenu: true,
        component: SuperUnionCheckDataStatistic,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
            {
                path: '/diamond_opening_start_statistic',
                title: getLanguage('diamondOpeningStartStatistic'),
                showMenu: true,
                component: DiamondOpeningStartStatistic,
            },
            {
                path: '/diamond_exchange_integral_statistic',
                title: getLanguage('diamondExchangeIntegralStatistic'),
                showMenu: true,
                component: DiamondExchangeIntegralStatistic,
            },
            {
                path: '/diamond_distribution_statistic',
                title: getLanguage('diamondDistributionStatistic'),
                showMenu: true,
                component: DiamondDistributionStatistic,
            },
            {
                path: '/diamond_record',
                title: getLanguage('diamondRecord'),
                showMenu: true,
                component: DiamondRecord,
            },
        ],
    },
    {
        path: '/activity_manage',
        title: getLanguage('activityManage'),
        icon: 'credit-card',
        showMenu: true,
        children: [
            {
                path: '/activity_lucky_card_record',
                title: getLanguage('activityLuckyCardRecord'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRecord,
            },
            {
                path: '/activity_bad_beat_jackpot_reward_record',
                title: getLanguage('activityBadBeatJackpotRewardRecord'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpotRewardRecord,
            },
            {
                path: '/activity_daily_challenge_record',
                title: getLanguage('dailyChallengeRecord'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeRecord,
            },
            {
                path: '/activity_daily_challenge_detail',
                title: getLanguage('dailyChallengeDetail'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeDetail,
            },
        ],
    },
    {
        path: '/union_manage',
        title: getLanguage('unionManage'),
        icon: 'apartment',
        showMenu: true,
        children: [
            {
                path: '/union_list',
                title: getLanguage('unionList'),
                showMenu: true,
                component: SuperUnionUnionList,
            },
            {
                path: '/union_detail/:union_id',
                title: getLanguage('unionDetail'),
                showMenu: false,
                component: SuperUnionUnionDetail,
            },
        ],
    },
    {
        path: '/club_manage',
        title: getLanguage('clubManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('clubList'),
                showMenu: true,
                component: SuperUnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('clubDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/code_send_record',
        title: getLanguage('codeSendRecord'),
        icon: 'history',
        showMenu: true,
        component: SuperUnionCodeSendRecord,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 超盟管理层
 */
export const superUnionAdminManagementMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: SuperUnionIncomeStatistic,
    },
    {
        path: '/lower_level_statistic',
        title: getLanguage('lowerLevelStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: SuperUnionLowerLevelStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: SuperUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: SuperUnionIntegralConsumeStatistic,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
        ],
    },
    {
        path: '/activity_manage',
        title: getLanguage('activityManage'),
        icon: 'credit-card',
        showMenu: true,
        children: [
            {
                path: '/activity_lucky_card',
                title: getLanguage('activityLuckyCard'),
                showMenu: true,
                component: SuperUnionActivityLuckycard,
            },
            {
                path: '/activity_lucky_card_record',
                title: getLanguage('activityLuckyCardRecord'),
                showMenu: true,
                component: SuperUnionActivityLuckycardRecord,
            },
            {
                path: '/activity_bad_beat_jackpot_reward_record',
                title: getLanguage('activityBadBeatJackpotRewardRecord'),
                showMenu: true,
                component: SuperUnionActivityBadBeatJackpotRewardRecord,
            },
            {
                path: '/activity_daily_challenge_record',
                title: getLanguage('dailyChallengeRecord'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeRecord,
            },
            {
                path: '/activity_daily_challenge_detail',
                title: getLanguage('dailyChallengeDetail'),
                showMenu: true,
                component: SuperUnionActivityDailyChallengeDetail,
            },
            {
                path: '/activity_poster',
                title: getLanguage('activityPoster'),
                showMenu: true,
                component: SuperUnionActivityPoster,
            },
        ],
    },
    {
        path: '/union_manage',
        title: getLanguage('unionManage'),
        icon: 'apartment',
        showMenu: true,
        children: [
            {
                path: '/union_list',
                title: getLanguage('unionList'),
                showMenu: true,
                component: SuperUnionUnionList,
            },
            {
                path: '/union_detail/:union_id',
                title: getLanguage('unionDetail'),
                showMenu: false,
                component: SuperUnionUnionDetail,
            },
        ],
    },
    {
        path: '/club_manage',
        title: getLanguage('clubManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('clubList'),
                showMenu: true,
                component: SuperUnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('clubDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/partner_manage',
        title: getLanguage('partnerManage'),
        icon: 'alert',
        showMenu: true,
        children: [
            {
                path: '/partner_card_query',
                title: getLanguage('partnerCardQuery'),
                showMenu: true,
                component: SuperUnionPartnerCardQuery,
            },
            {
                path: '/partner_card_statistic',
                title: getLanguage('partnerCardStatistic'),
                showMenu: true,
                component: SuperUnionPartnerCardStatistic,
            },
        ],
    },
    {
        path: '/derivative_detection',
        title: getLanguage('derivativeDetection'),
        icon: 'bulb',
        showMenu: true,
        component: SuperUnionDerivativeDetection,
    },
    {
        path: '/code_send_record',
        title: getLanguage('codeSendRecord'),
        icon: 'history',
        showMenu: true,
        component: SuperUnionCodeSendRecord,
    },
    {
        path: '/customer_manage',
        title: getLanguage('customerManage'),
        icon: 'message',
        showMenu: true,
        component: SuperUnionCustomerManage,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

// ############################################################################################## 联盟 ##############################################################################################
/**
 * 联盟主
 */
export const unionMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: UnionIncomeStatistic,
    },
    {
        path: '/payment_statistic',
        title: getLanguage('paymentStatistic'),
        icon: 'vertical-align-top',
        showMenu: true,
        component: UnionPaymentStatistic,
    },
    {
        path: '/lower_payment_statistic',
        title: getLanguage('lowerLevelPaymentStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: UnionLowerLevelPaymentStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: UnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: UnionConsumeIntegralStatistic,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
            {
                path: '/diamond_opening_start_statistic',
                title: getLanguage('diamondOpeningStartStatistic'),
                showMenu: true,
                component: DiamondOpeningStartStatistic,
            },
            {
                path: '/diamond_distribution_statistic',
                title: getLanguage('diamondDistributionStatistic'),
                showMenu: true,
                component: DiamondDistributionStatistic,
            },
            {
                path: '/diamond_record',
                title: getLanguage('diamondRecord'),
                showMenu: true,
                component: DiamondRecord,
            },
        ],
    },
    {
        path: '/club_manage',
        title: getLanguage('clubManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('clubList'),
                showMenu: true,
                component: UnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('clubDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/local_currency_ratio',
        title: getLanguage('localCurrencyRatio'),
        icon: 'interaction',
        showMenu: true,
        component: UnionLocalCurrencyRatio,
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 联盟vip
 */
export const unionVipMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: UnionIncomeStatistic,
    },
    {
        path: '/payment_statistic',
        title: getLanguage('paymentStatistic'),
        icon: 'vertical-align-top',
        showMenu: true,
        component: UnionPaymentStatistic,
    },
    {
        path: '/lower_payment_statistic',
        title: getLanguage('lowerLevelPaymentStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: UnionLowerLevelPaymentStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: UnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: UnionConsumeIntegralStatistic,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
            {
                path: '/diamond_opening_start_statistic',
                title: getLanguage('diamondOpeningStartStatistic'),
                showMenu: true,
                component: DiamondOpeningStartStatistic,
            },
            {
                path: '/diamond_distribution_statistic',
                title: getLanguage('diamondDistributionStatistic'),
                showMenu: true,
                component: DiamondDistributionStatistic,
            },
            {
                path: '/diamond_record',
                title: getLanguage('diamondRecord'),
                showMenu: true,
                component: DiamondRecord,
            },
        ],
    },
    {
        path: '/club_manage',
        title: getLanguage('clubManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('clubList'),
                showMenu: true,
                component: UnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('clubDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/local_currency_ratio',
        title: getLanguage('localCurrencyRatio'),
        icon: 'interaction',
        showMenu: true,
        component: UnionLocalCurrencyRatio,
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '/account_switch',
        title: getLanguage('accountSwitch'),
        showMenu: false,
        component: AccountSwitch,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 联盟管理员
 */
export const unionAdminMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: UnionIncomeStatistic,
    },
    {
        path: '/payment_statistic',
        title: getLanguage('paymentStatistic'),
        icon: 'vertical-align-top',
        showMenu: true,
        component: UnionPaymentStatistic,
    },
    {
        path: '/lower_payment_statistic',
        title: getLanguage('lowerLevelPaymentStatistic'),
        icon: 'vertical-align-bottom',
        showMenu: true,
        component: UnionLowerLevelPaymentStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: UnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: UnionConsumeIntegralStatistic,
    },
    {
        path: '/diamond_manage',
        title: getLanguage('diamondManage'),
        icon: 'sketch',
        showMenu: true,
        children: [
            {
                path: '/diamond_statistic',
                title: getLanguage('diamondStatistic'),
                showMenu: true,
                component: DiamondStatistic,
            },
            {
                path: '/diamond_opening_start_statistic',
                title: getLanguage('diamondOpeningStartStatistic'),
                showMenu: true,
                component: DiamondOpeningStartStatistic,
            },
            {
                path: '/diamond_distribution_statistic',
                title: getLanguage('diamondDistributionStatistic'),
                showMenu: true,
                component: DiamondDistributionStatistic,
            },
            {
                path: '/diamond_record',
                title: getLanguage('diamondRecord'),
                showMenu: true,
                component: DiamondRecord,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/local_currency_ratio',
        title: getLanguage('localCurrencyRatio'),
        icon: 'interaction',
        showMenu: true,
        component: UnionLocalCurrencyRatio,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 联盟客服
 */
export const unionAdminServiceMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/player_list',
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
        ],
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

// ############################################################################################## 直营联盟 ##############################################################################################
/**
 * 直营联盟主
 */
export const directUnionMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: DirectUnionIncomeStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: DirectUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: DirectUnionIntegralConsumeStatistic,
    },
    {
        path: '/lower_level_proxy_statistic',
        title: getLanguage('lowerLevelProxyStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: DirectUnionLowerLevelProxyStatistic,
    },
    {
        path: '/proxy_manage',
        title: getLanguage('proxyManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('proxyList'),
                showMenu: true,
                component: DirectUnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('proxyDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 直营联盟vip
 */
export const directUnionVipMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: DirectUnionIncomeStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: DirectUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: DirectUnionIntegralConsumeStatistic,
    },
    {
        path: '/lower_level_proxy_statistic',
        title: getLanguage('lowerLevelProxyStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: DirectUnionLowerLevelProxyStatistic,
    },
    {
        path: '/proxy_manage',
        title: getLanguage('proxyManage'),
        icon: 'flag',
        showMenu: true,
        children: [
            {
                path: '/club_list',
                title: getLanguage('proxyList'),
                showMenu: true,
                component: DirectUnionClubList,
            },
            {
                path: '/club_detail/:club_id',
                title: getLanguage('proxyDetail'),
                showMenu: false,
                component: ClubDetail,
            },
        ],
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '/account_switch',
        title: getLanguage('accountSwitch'),
        showMenu: false,
        component: AccountSwitch,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 直营联盟管理员
 */
export const directUnionAdminMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/overview',
    },
    {
        path: '/overview',
        title: getLanguage('overview'),
        icon: 'snippets',
        showMenu: true,
        component: Overview,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: DirectUnionIncomeStatistic,
    },
    {
        path: '/game_statistic',
        title: getLanguage('gameStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: DirectUnionGameStatistic,
    },
    {
        path: '/integral_consume_statistic',
        title: getLanguage('integralConsumeStatistic'),
        icon: 'dollar',
        showMenu: true,
        component: DirectUnionIntegralConsumeStatistic,
    },
    {
        path: '/lower_level_proxy_statistic',
        title: getLanguage('lowerLevelProxyStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: DirectUnionLowerLevelProxyStatistic,
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * 直营联盟客服
 */
export const directUnionAdminServiceMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/player_list',
    },
    {
        path: '/player_manage',
        title: getLanguage('playerManage'),
        icon: 'user',
        showMenu: true,
        children: [
            {
                path: '/player_list',
                title: getLanguage('playerList'),
                showMenu: true,
                component: PlayerList,
            },
            {
                path: '/player_statistic',
                title: getLanguage('playerStatistic'),
                showMenu: true,
                component: PlayerStatistic,
            },
            {
                path: '/player_detail/:user_id/:club_id',
                title: getLanguage('playerDetail'),
                showMenu: false,
                component: PlayerDetail,
            },
        ],
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
        ],
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

// ############################################################################################## Kpoker联盟 ##############################################################################################
/**
 * Kpoker联盟主
 */
export const kpokerUnionMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/proxy_list',
    },
    {
        path: '/proxy_list',
        title: getLanguage('proxyList'),
        icon: 'rocket',
        showMenu: true,
        component: KpokerProxyList,
    },
    {
        path: '/proxy_detail/:proxy_id',
        title: getLanguage('proxyDetail'),
        showMenu: false,
        component: KpokerProxyDetail,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIncomeStatistic,
    },
    {
        path: '/income_record',
        title: getLanguage('incomeRecord'),
        icon: 'account-book',
        showMenu: true,
        component: KpokerIncomeRecord,
    },
    {
        path: '/payment_statistic',
        title: getLanguage('paymentStatistic'),
        icon: 'vertical-align-top',
        showMenu: true,
        component: KpokerPaymentStatistic,
    },
    {
        path: '/proxy_statistic',
        title: getLanguage('proxyStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: KpokerProxyStatistic,
    },
    {
        path: '/palyer_statistic',
        title: getLanguage('playerStatistic'),
        icon: 'user',
        showMenu: true,
        component: KpokerPalyerStatistic,
    },
    {
        path: '/gambling_record',
        title: getLanguage('gamblingRecord'),
        icon: 'trophy',
        showMenu: true,
        component: KpokerGamblingRecord,
    },
    {
        path: '/bet_record',
        title: getLanguage('betRecord'),
        icon: 'dollar',
        showMenu: true,
        component: KpokerBetRecord,
    },
    {
        path: '/integral_record',
        title: getLanguage('integralRecord'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIntegralRecord,
    },
    {
        path: '/props_consume_record',
        title: getLanguage('propsConsumeRecord'),
        icon: 'thunderbolt',
        showMenu: true,
        component: KpokerPropConsumeRecord,
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/integral_proportion',
        title: getLanguage('integralProportion'),
        icon: 'percentage',
        showMenu: true,
        component: KpokerIntegralProportion,
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * Kpoker联盟vip
 */
export const kpokerUnionVipMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/proxy_list',
    },
    {
        path: '/proxy_list',
        title: getLanguage('proxyList'),
        icon: 'rocket',
        showMenu: true,
        component: KpokerProxyList,
    },
    {
        path: '/proxy_detail/:proxy_id',
        title: getLanguage('proxyDetail'),
        showMenu: false,
        component: KpokerProxyDetail,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIncomeStatistic,
    },
    {
        path: '/income_record',
        title: getLanguage('incomeRecord'),
        icon: 'account-book',
        showMenu: true,
        component: KpokerIncomeRecord,
    },
    {
        path: '/payment_statistic',
        title: getLanguage('paymentStatistic'),
        icon: 'vertical-align-top',
        showMenu: true,
        component: KpokerPaymentStatistic,
    },
    {
        path: '/proxy_statistic',
        title: getLanguage('proxyStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: KpokerProxyStatistic,
    },
    {
        path: '/palyer_statistic',
        title: getLanguage('playerStatistic'),
        icon: 'user',
        showMenu: true,
        component: KpokerPalyerStatistic,
    },
    {
        path: '/gambling_record',
        title: getLanguage('gamblingRecord'),
        icon: 'trophy',
        showMenu: true,
        component: KpokerGamblingRecord,
    },
    {
        path: '/bet_record',
        title: getLanguage('betRecord'),
        icon: 'dollar',
        showMenu: true,
        component: KpokerBetRecord,
    },
    {
        path: '/integral_record',
        title: getLanguage('integralRecord'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIntegralRecord,
    },
    {
        path: '/props_consume_record',
        title: getLanguage('propsConsumeRecord'),
        icon: 'thunderbolt',
        showMenu: true,
        component: KpokerPropConsumeRecord,
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/integral_proportion',
        title: getLanguage('integralProportion'),
        icon: 'percentage',
        showMenu: true,
        component: KpokerIntegralProportion,
    },
    {
        path: '/account_manage',
        title: getLanguage('accountManage'),
        icon: 'security-scan',
        showMenu: true,
        component: AccountManage,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * Kpoker联盟管理员
 */
export const kpokerUnionAdminMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/proxy_list',
    },
    {
        path: '/proxy_list',
        title: getLanguage('proxyList'),
        icon: 'rocket',
        showMenu: true,
        component: KpokerProxyList,
    },
    {
        path: '/proxy_detail/:proxy_id',
        title: getLanguage('proxyDetail'),
        showMenu: false,
        component: KpokerProxyDetail,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIncomeStatistic,
    },
    {
        path: '/income_record',
        title: getLanguage('incomeRecord'),
        icon: 'account-book',
        showMenu: true,
        component: KpokerIncomeRecord,
    },
    {
        path: '/payment_statistic',
        title: getLanguage('paymentStatistic'),
        icon: 'vertical-align-top',
        showMenu: true,
        component: KpokerPaymentStatistic,
    },
    {
        path: '/proxy_statistic',
        title: getLanguage('proxyStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: KpokerProxyStatistic,
    },
    {
        path: '/palyer_statistic',
        title: getLanguage('playerStatistic'),
        icon: 'user',
        showMenu: true,
        component: KpokerPalyerStatistic,
    },
    {
        path: '/gambling_record',
        title: getLanguage('gamblingRecord'),
        icon: 'trophy',
        showMenu: true,
        component: KpokerGamblingRecord,
    },
    {
        path: '/bet_record',
        title: getLanguage('betRecord'),
        icon: 'dollar',
        showMenu: true,
        component: KpokerBetRecord,
    },
    {
        path: '/integral_record',
        title: getLanguage('integralRecord'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIntegralRecord,
    },
    {
        path: '/props_consume_record',
        title: getLanguage('propsConsumeRecord'),
        icon: 'thunderbolt',
        showMenu: true,
        component: KpokerPropConsumeRecord,
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_config_list',
                title: getLanguage('tableConfigList'),
                showMenu: true,
                component: TableConfigList,
            },
            {
                path: '/table_round_list',
                title: getLanguage('tableRoundList'),
                showMenu: true,
                component: TableRoundList,
            },
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
            {
                path: '/table_config_statistic',
                title: getLanguage('tableConfigStatistic'),
                showMenu: true,
                component: TableConfigStatistic,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_create',
                title: getLanguage('mttCreate'),
                showMenu: false,
                component: MttCreate,
            },
            {
                path: '/mtt_list',
                title: getLanguage('mttList'),
                showMenu: true,
                component: MttList,
            },
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
            {
                path: '/mtt_ticket_list',
                title: getLanguage('mttTicketList'),
                showMenu: true,
                component: MttTicketList,
            },
            {
                path: '/mtt_data_statistic',
                title: getLanguage('mttDataStatistic'),
                showMenu: true,
                component: MttDataStatistic,
            },
        ],
    },
    {
        path: '/integral_proportion',
        title: getLanguage('integralProportion'),
        icon: 'percentage',
        showMenu: true,
        component: KpokerIntegralProportion,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]

/**
 * Kpoker联盟客服
 */
export const kpokerUnionAdminServiceMenu = [
    {
        path: '/',
        showMenu: false,
        exact: true,
        redirect: '/proxy_list',
    },
    {
        path: '/proxy_list',
        title: getLanguage('proxyList'),
        icon: 'rocket',
        showMenu: true,
        component: KpokerProxyList,
    },
    {
        path: '/proxy_detail/:proxy_id',
        title: getLanguage('proxyDetail'),
        showMenu: false,
        component: KpokerProxyDetail,
    },
    {
        path: '/income_statistic',
        title: getLanguage('incomeStatistic'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIncomeStatistic,
    },
    {
        path: '/income_record',
        title: getLanguage('incomeRecord'),
        icon: 'account-book',
        showMenu: true,
        component: KpokerIncomeRecord,
    },
    {
        path: '/payment_statistic',
        title: getLanguage('paymentStatistic'),
        icon: 'vertical-align-top',
        showMenu: true,
        component: KpokerPaymentStatistic,
    },
    {
        path: '/proxy_statistic',
        title: getLanguage('proxyStatistic'),
        icon: 'dashboard',
        showMenu: true,
        component: KpokerProxyStatistic,
    },
    {
        path: '/palyer_statistic',
        title: getLanguage('playerStatistic'),
        icon: 'user',
        showMenu: true,
        component: KpokerPalyerStatistic,
    },
    {
        path: '/gambling_record',
        title: getLanguage('gamblingRecord'),
        icon: 'trophy',
        showMenu: true,
        component: KpokerGamblingRecord,
    },
    {
        path: '/bet_record',
        title: getLanguage('betRecord'),
        icon: 'dollar',
        showMenu: true,
        component: KpokerBetRecord,
    },
    {
        path: '/integral_record',
        title: getLanguage('integralRecord'),
        icon: 'transaction',
        showMenu: true,
        component: KpokerIntegralRecord,
    },
    {
        path: '/props_consume_record',
        title: getLanguage('propsConsumeRecord'),
        icon: 'thunderbolt',
        showMenu: true,
        component: KpokerPropConsumeRecord,
    },
    {
        path: '/table_manage',
        title: getLanguage('tableManage'),
        icon: 'table',
        showMenu: true,
        children: [
            {
                path: '/table_round_record_list',
                title: getLanguage('tableRoundRecordList'),
                showMenu: true,
                component: TableRoundRecordList,
            },
        ],
    },
    {
        path: '/mtt_manage',
        title: getLanguage('mttManage'),
        icon: 'radar-chart',
        showMenu: true,
        children: [
            {
                path: '/mtt_round_list',
                title: getLanguage('mttRoundList'),
                showMenu: true,
                component: MttRoundList,
            },
        ],
    },
    {
        path: '/integral_proportion',
        title: getLanguage('integralProportion'),
        icon: 'percentage',
        showMenu: true,
        component: KpokerIntegralProportion,
    },
    {
        path: '/account_setting',
        title: getLanguage('accountSetting'),
        icon: 'setting',
        showMenu: true,
        component: AccountSetting,
    },
    {
        path: '*',
        showMenu: false,
        component: Page404,
    },
]
